/* Copyright 2023 (Unpublished) Verto Inc. */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { MessageService } from 'primeng/api';

// Is the component that code flow redirects to.
// Handles the auth code <-> access token exchange using angular-oauth2-oidc.
@Component({ template: '' })
export class OAuthRedirectComponent implements OnInit {
  constructor(
    private _oAuthService: OAuthService,
    private _router: Router,
    private _messageService: MessageService
  ) {}

  ngOnInit() {
    this._oAuthService
      .loadDiscoveryDocumentAndTryLogin()
      // redirect to executions after successful login
      .then(() => {
        const state = this._oAuthService.state;
        if (state) {
          this._router.navigateByUrl(decodeURIComponent(state));
        } else {
          this._router.navigate(['/executions']);
        }
      })
      .catch((reason) => {
        this._router.navigate(['/login']);
        this._messageService.add({
          severity: 'error',
          summary: 'Failed to login',
          detail:
            typeof reason === 'string'
              ? `${reason}`
              : 'Could not authenticate with Flow',
        });
      });
  }
}
